import moment from "moment";

function FormataData(data: string | undefined): string {
    return moment(data).format('DD/MM/YYYY');
}

export default FormataData;